import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { SportSuspensionsEditorResponse } from "@/types/ApiResponses/Sport";

export interface GetSportsSuspensionsParams {
  lang?: string;
  targetUsername?: string;
}

export const getSportsSuspensions = async (
  props: QueryProps<GetSportsSuspensionsParams>
): Promise<SportSuspensionsEditorResponse> => {
  const res = await api.client.get(`/sports-new/suspensions`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
